import React, { useEffect } from 'react';
import { Button, Card, Descriptions, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { STBGroupContext } from '@layouts/devices/STBGroup/index';
import { useHistory, useParams } from 'react-router-dom';
import { StbGroupExtended } from '@services/types';
import { Navigation } from '@constants/Navigation';
import api from '@services/api';

const InfoStbGroupPage: React.FC = () => {
  const { deviceTypes } = React.useContext(STBGroupContext);
  const [stbGroupToInfo, setStbGroupToInfo] = React.useState<StbGroupExtended>();

  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    const data = async () => {
      if (id) {
        const stbGroup = await api.stbGroups.getStbGroupsById(id);
        setStbGroupToInfo({
          ...stbGroup,
          deviceTypeName: deviceTypes.find((deviceType) => deviceType.id === stbGroup.deviceTypeId)?.deviceName,
        });
      }
    };
    data();
  }, [id, deviceTypes]);

  const onClose = () => {
    history.push(Navigation.STBGroup);
  };

  return (
    <Card
      title={stbGroupToInfo?.name}
      style={{ marginBottom: '1rem' }}
      extra={
        <Space>
          <Button icon={<ArrowLeftOutlined />} type="default" onClick={onClose}>
            Back to StbGroup Page
          </Button>
        </Space>
      }
    >
      <Descriptions labelStyle={{ fontWeight: '500', fontSize: '16px' }} layout="horizontal" column={2} bordered>
        <Descriptions.Item label="Name">{stbGroupToInfo?.name}</Descriptions.Item>
        <Descriptions.Item label="Description">{stbGroupToInfo?.description}</Descriptions.Item>
        <Descriptions.Item label="Size">{stbGroupToInfo?.etc.deviceCount}</Descriptions.Item>
        <Descriptions.Item label="Device Type">{stbGroupToInfo?.deviceTypeName}</Descriptions.Item>
        <Descriptions.Item label="Scope">{stbGroupToInfo?.etc.superGroupName}</Descriptions.Item>
        <Descriptions.Item label="Upgrade Rule">{stbGroupToInfo?.etc.upgradeRuleName}</Descriptions.Item>
        <Descriptions.Item label="Deployment Mode">{stbGroupToInfo?.deploymentMode}</Descriptions.Item>
        <Descriptions.Item label="Quota enabled">{stbGroupToInfo?.enableQuota?.toLocaleString()}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default React.memo(InfoStbGroupPage);
